import { Component, OnInit } from "@angular/core";
import { SharedService } from "src/app/shared/services/shared.service";
import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from "@angular/router";

@Component({
  selector: "app-base",
  templateUrl: "./base.component.html",
  styleUrls: ["./base.component.scss"]
})
export class BaseComponent implements OnInit {
  public isLoading: any;
  changingRoute: boolean = false;

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.changingRoute = true;
    }
    if (event instanceof NavigationEnd) {
      this.changingRoute = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.changingRoute = false;
    }
    if (event instanceof NavigationError) {
      this.changingRoute = false;
    }
  }
  constructor(
    private router: Router,
    public sharedService: SharedService
  ) {
    this.router.events.subscribe((e: RouterEvent) => {
      this.navigationInterceptor(e);
    });
    //
    // this.isLoading = true;
    // // this.isLoading = sharedService.isLoading;
    // if (this.isLoading == undefined) {
    //   this.isLoading = false;
    // }
    // // Spinner for lazyload modules
    // router.events.forEach((event) => {
    //   if (event instanceof RouteConfigLoadStart) {
    //     // this.isLoading = true;
    //   } else if (event instanceof RouteConfigLoadEnd) {
    //     // this.isLoading = false;
    //   }
    // });
    // this.sharedService.currentloader.subscribe(load => (this.isLoading = load));
  }

  ngOnInit(): void {
    this.sharedService.currentloader.subscribe(
      (load) => (this.isLoading = load)
    ); //<= Always get current value!
  }
}
